import React, { useState } from "react";
import { FaBoxOpen, FaMapMarkerAlt, FaHeart, FaCreditCard, FaCog, FaSignOutAlt } from "react-icons/fa";
import { motion } from "framer-motion";
import InvoicePage from "./invoicePage"; 
import EditProfile from "./EditProfiles";
import Images  from "../image/1732543742.jpg";
import OrderTracking from "./orderTracking";

const Profile = () => {
  const [activeTab, setActiveTab] = useState("My Orders");
  const [selectedOrder, setSelectedOrder] = useState(null);
   const [selectedInvoice, setSelectedInvoice] = useState(null);

  const orders = [
    {
      id: "#1001",
      date: "15-Aug-2025",
      product: "Organic Green Tea (250g)",
      price: 1250,
      qty: 1,
      payment: "Prepaid",
      img: "https://via.placeholder.com/120",
      status: "completed",
    },
    {
      id: "#1002",
      date: "10-Aug-2025",
      product: "Herbal Shampoo (500ml)",
      price: 899,
      qty: 2,
      payment: "COD",
      img: "https://via.placeholder.com/120",
      status: "shipped",
    },
  ];

  const statusSteps = ["placed", "shipped", "out-for-delivery", "delivered"];

  const SidebarItem = ({ title, icon }) => (
    <div
      className={`sidebar-item ${activeTab === title ? "active" : ""}`}
      onClick={() => setActiveTab(title)}
    >
      <span className="sidebar-icon">{icon}</span>
      <span>{title}</span>
    </div>
  );

  const handleCancelOrder = (orderId) => {
    alert(`Order ${orderId} has been cancelled!`);
  };

  const OrderCard = ({ order }) => {
    const currentIndex = statusSteps.indexOf(order.status);
    return (
      <motion.div
        className="order-card"
        initial={{ opacity: 0, y: 40 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.5 }}
      >
        <div className="order-top">
          <div>
            <strong>{order.id}</strong> • Placed on {order.date}
          </div>
        
        </div>

        <div className="order-body d-flex gap-5">
          <img src={Images} alt="Product" className="order-img" />
          <div className="order-info">
            <h5>{order.product}</h5>
            <p>Qty: {order.qty} | Payment: {order.payment}</p>
            <p className="price">₹{order.price}</p>
          </div>
           <OrderTracking status= {order.status} />  
        </div>

        {/* Status Tracker */}
         

        <div className="order-actions">
          <button
            className="btn-outline"
            disabled={order.status === "delivered"}
            onClick={() => handleCancelOrder(order.id)}
          >
            Cancel Order
          </button>

         <div className="order-actions">
        <button className="btn-primary" onClick={() => handleViewInvoice(order)}>
          View Invoice
        </button>
      </div>
        </div>
      </motion.div>
    );
  };
  const handleViewInvoice = (order) => {
    const invoiceData = {
      invoiceNo: "INV-2025-001",
      orderDate: order.date,
      orderId: order.id,
      paymentMethod: order.payment,
      delivery: 50,
      discount: 100,
      note: "Thank you for shopping with us!",
      seller: {
        name: "Organic Store Pvt. Ltd.",
        address: "123 Green Street, Pune",
        gstin: "27ABCDE1234F1Z5",
        phone: "+91 98765 43210",
      },
      buyer: {
        name: "John Doe",
        address: "456 Eco Avenue, Mumbai",
        phone: "+91 99999 88888",
      },
      items: [
        { id: 1, title: order.product, qty: order.qty, price: order.price },
      ],
    };
    setSelectedInvoice(invoiceData);
    setActiveTab("Invoice");
  };

  return (
    <>
      <style>{`
        /* Container & Layout */
        .profile-container { display:flex; min-height:100vh; font-family: var(--font-primary); margin-top: 120px; background: var(--bg-accent); }
        .sidebar { width: 260px; background: var(--bg-light); border-right:1px solid var(--color-muted); padding: var(--space-md); position: sticky; top:0; height:100vh; }
        .profile-info { text-align:center; margin-bottom: var(--space-lg); }
        .profile-info .avatar { width:80px; height:80px; background: var(--color-accent); border-radius:50%; margin:0 auto 10px; font-size:36px; display:flex; justify-content:center; align-items:center; }
        .sidebar-menu { display:flex; flex-direction: column; gap: var(--space-xs); }
        .sidebar-item { display:flex; align-items:center; gap: var(--space-xs); padding:10px; border-radius: var(--border-radius-btn); color: var(--color-text); cursor:pointer; font-size: var(--font-base); transition: all 0.3s ease; }
        .sidebar-item:hover { background: var(--color-accent); color: var(--color-primary); }
        .sidebar-item.active { background: var(--color-accent); color: var(--color-primary); font-weight:bold; }

        .content { flex:1; padding: var(--space-lg); }
        .content-header { display:flex; justify-content:space-between; align-items:center; margin-bottom: var(--space-md); }

        /* Orders */
        .orders-section { display:flex; flex-direction:column; gap: var(--space-md); }
        .order-card { background: var(--bg-light); border-radius: var(--border-radius-btn); padding: var(--padding-card); box-shadow: var(--box-shadow-card); border:1px solid var(--color-accent); transition: var(--box-shadow-hover); }
        .order-card:hover { box-shadow: var(--box-shadow-hover); transform: translateY(-3px); }

        .order-top { display:flex; justify-content:space-between; margin-bottom: var(--space-xs); font-size: var(--font-sm); }
        .badge { padding: 4px 10px; border-radius: var(--border-radius-btn); font-size: var(--font-xs); font-weight:bold; text-transform:uppercase; }
        .badge.placed { background:#ffd54d; color: var(--color-text); }
        .badge.shipped { background: var(--color-primary); color: var(--color-secondary); }
        .badge.out-for-delivery { background:#ff9800; color: var(--color-secondary); }
        .badge.delivered { background: var(--color-primary); color: var(--color-secondary); }

        .order-body { display:flex; gap: var(--space-md); align-items:center; margin-bottom: var(--space-sm); }
        .order-img { width:120px; height:120px; border-radius: var(--border-radius-btn); object-fit:cover; border:1px solid var(--color-accent); }
        .order-info h5 { margin:0 0 5px; font-size: var(--font-base); font-weight:bold; color: var(--color-text); }
        .order-info p { margin:0; font-size: var(--font-sm); color: var(--color-muted); }
        .price { font-weight:600; color: var(--color-primary); font-size: var(--font-base); margin-top:4px; }

        .order-status { position:relative; margin-bottom: var(--space-sm); height:40px; }
        .progress-bar { position:absolute; top:18px; left:0; height:4px; background: var(--color-primary); border-radius:2px; z-index:1; }
        .order-step { position:relative; display:inline-block; text-align:center; width:25%; }
        .order-step .order-circle { width:16px; height:16px; border-radius:50%; background: var(--color-muted); margin:0 auto 4px; z-index:2; position:relative; }
        .order-step.completed .order-circle { background: var(--color-primary); }
        .order-step.active .order-circle { background: var(--color-ternary); }
        .order-step span { font-size: var(--font-xs); text-transform:capitalize; color: var(--color-muted); }

        .order-actions { display:flex; gap: var(--space-xs); margin-top: var(--space-xs); }
        .btn-primary { background: var(--color-primary); color: var(--color-secondary); border:none; padding:10px 16px; border-radius: var(--border-radius-btn); cursor:pointer; transition:0.3s; }
        .btn-primary:hover { transform:translateY(-2px); }
        .btn-outline { background:transparent; border:1px solid var(--color-primary); color:var(--color-primary); padding:10px 16px; border-radius: var(--border-radius-btn); cursor:pointer; transition:0.3s; }
        .btn-outline:disabled { opacity:0.6; cursor:not-allowed; }
        .btn-outline:hover:not(:disabled) { background:var(--color-primary); color:var(--color-secondary); }

        @media(max-width:768px){ 
          .order-body { flex-direction:column; align-items:flex-start; } 
          .order-img { width:100%; height:auto; } 
          .order-step { width:24%; } 
        }
      `}</style>

      <div className="profile-container">
        <aside className="sidebar">
          <div className="profile-info">
            <div className="avatar">👤</div>
            <h2>User Name</h2>
            <p>useremail@example.com</p>
          </div>
          <nav className="sidebar-menu">
            <SidebarItem title="My Orders" icon={<FaBoxOpen />} />
            <SidebarItem title="Saved Addresses" icon={<FaMapMarkerAlt />} />
            <SidebarItem title="Wishlist" icon={<FaHeart />} />
            <SidebarItem title="Payment Methods" icon={<FaCreditCard />} />
            <SidebarItem title="Settings" icon={<FaCog />} />
            <SidebarItem title="Logout" icon={<FaSignOutAlt />} />
          </nav>
        </aside>

        <main className="content">
          <div className="content-header">
            <h1>{activeTab}</h1>
            {activeTab === "My Orders" && (
              <button className="btn-outline" onClick={() => setActiveTab("Edit Profile")}>
                Edit Profile
              </button>
            )}
          </div>

          {activeTab === "My Orders" && (
            <div className="orders-section">
              {orders.map((order) => (
                <OrderCard key={order.id} order={order} />
              ))}
            </div>
          )}

           {activeTab === "Invoice" && selectedInvoice && (
          <InvoicePage invoice={selectedInvoice} />
        )}
          {activeTab === "Edit Profile" && <EditProfile />}
        </main>
      </div>
    </>
  );
};

export default Profile;
